import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  node: (open: boolean) => ({
    border: '1px solid',
    borderColor: open ? 'primary.main' : 'var(--grey-300)',
    borderRadius: '8px',
    mb: '10px',
    overflow: 'hidden',
    backgroundColor: 'var(--white)'
  } satisfies SxProps<Theme>),
  body: {
    px: '12px',
    pb: '4px',
    pt: '10px'
  } satisfies SxProps<Theme>
}
